module.exports = __webpack_public_path__ + "img\\bcpw_thumbnaill_img.1da3c6c0.png";